import type { Assignment } from "../SettingsPayload";
import { generationSettingStore } from "../store/SettingsGenerationSettingStore";
import { narrowSkipTargets } from "./narrowSkipTargets";
import { parseMentions } from "./parseMentions";

/**
 * 担当の本文を settings へ書く。
 *
 * **本文を変えると対象が作り直される。** 本文中のメンションから対象を解析し、書き込まない旗も
 * **同じ瞬間に絞る**。絞らないと、消したメンションの旗が残り、貼り直した対象が外れた状態で
 * 現れる。
 *
 * **直す場所が 2 つあるので、作法をここへ集める。** 担当のペインと生成結果の行が同じ本文を
 * 直すため、それぞれで組み立てると片方だけ対象の作り直しが抜ける
 * （[[2026-09-10 設計ノート アドイン 生成結果画面の結果情報対応]]）。
 *
 * 保存先は pptx の settings である。**上書きレイヤーではない**ので、直した瞬間に手元の
 * ファイルが変わる。
 */
export function writeAssignmentInstruction(
    id: string,
    instruction: string,
    current: Assignment,
): void {
    const targets = parseMentions(instruction);
    generationSettingStore.writeAssignment(id, {
        ...current,
        instruction,
        targets,
        skipTargets: narrowSkipTargets(current.skipTargets, targets),
        updatedAt: new Date().toISOString(),
        updatedBy: "",
    });
}
